// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col } from '@crehana/ui';

import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

import AccountForm from './components/AccountForm';
import PaymentForm from './components/PaymentForm';
import RegisterForm from './components/RegisterForm';

const FORMS = {
  1: <RegisterForm />,
  2: <AccountForm />,
  3: <PaymentForm />,
};

const LeftUI = () => {
  const {
    state: { currentStep },
  } = useCheckoutCtx();

  return (
    <Col md={6} nowrap className="pt-24 sm:py-32 md:py-48">
      {FORMS[currentStep as keyof typeof FORMS]}
    </Col>
  );
};

export default LeftUI;
